import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';


export interface IInfoIconProps extends ISvgIconProps {

}

export class InfoIcon extends React.Component<IInfoIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g>
                    <path
                        fill="currentColor"
                        d="M14.42,10.69a19.18,19.18,0,0,1-.78,4.16,20.1,20.1,0,0,0-.78,3.86c0,.6.09.91.26.91a6.3,6.3,0,0,0,1.33-.55l.34-.17.49,1-.69.57a10.55,10.55,0,0,1-1.61.94,5,5,0,0,1-2.19.59,2.06,2.06,0,0,1-1.58-.62,2.33,2.33,0,0,1-.58-1.67A17.49,17.49,0,0,1,9.35,16a18,18,0,0,0,.72-3.5,3.88,3.88,0,0,0-.75-2.27l-.26-.35,0-.37A20,20,0,0,1,14,9.05,2.59,2.59,0,0,1,14.42,10.69Zm-3.28-4.8a2,2,0,0,1-.58-1.51,2.19,2.19,0,0,1,.79-1.67A2.65,2.65,0,0,1,13.18,2a2.15,2.15,0,0,1,1.61.58,2,2,0,0,1,.58,1.51,2.16,2.16,0,0,1-.82,1.66,2.72,2.72,0,0,1-1.83.72A2.14,2.14,0,0,1,11.14,5.89Z"
                    />
                </g>
            </SvgIcon>
        );
    }
}
